// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../node_modules/@types/glidejs__glide/index.d.ts" />
import{escapeSelector}from"@olmokit/dom/escapeSelector";import{listenResize}from"@olmokit/dom/listenResize";import Glide from"./glide.modular.esm";// import { Glide } from "@glidejs/glide";
import"./index.scss";/**
 * Init glidejs slider (custom fork)
 */export function init(selector,options,components){// allow to pass a DOM element or a selector. Escape it to allow the use of
// colons in HTML classNames
// @ts-expect-error FIXME: glide types?
let glide=new Glide(// @ts-expect-error FIXME: glide types?
"string"==typeof selector?escapeSelector(selector):selector,options);// FIXME: @styleloader
if("production"!==process.env.NODE_ENV){let _mount=glide.mount;// const _mount = glide.mount.bind(glide);
// @ts-expect-error FIXME: core types glide
glide.mount=function(components){setTimeout(()=>{_mount.call(glide,components)},50)}}// @see https://github.com/glidejs/glide/issues/208
if(options.killWhen){let{above,below}=options.killWhen,hasInit=!1,toggle=()=>{if(above&&window.innerWidth>=above||below&&window.innerWidth<below){if(hasInit){hasInit=!1;try{glide.destroy()}catch(e){// FIXME: sometimes the glide.Events class gives error, if resizing
// too fast maybe, not sure if this is a problem...
}// glide.disable();
}}else hasInit||(glide.mount(components),// if (!glide) {
//   glide = /** @type {glideInstance} */ (new Glide(
//     typeof selector === "string" ? escape(selector) : selector,
//     options
//   )).mount(components);;
// } else {
//   glide.mount(components);
// }
hasInit=!0)},listenerResize=listenResize(toggle);// @ts-expect-error FIXME: core glide types
glide.on("destroy",listenerResize),toggle()}// return the glide instance, with its default API,
// @see https://glidejs.com/docs/api/
return glide}